import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('API Error:', error);

      // Only treat a 401 as "session expired, log out" when the request was
      // actually authenticated (had a Bearer token attached by authInterceptor).
      // The creator auth endpoints themselves (send-otp/verify-otp/resend-otp)
      // legitimately return 401 for things like a wrong/expired OTP — that's a
      // normal, recoverable, user-facing error, not a session expiry.
      if (error.status === 401 && req.headers.has('Authorization')) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        router.navigate(['/login']);
      }
      return throwError(() => error);
    }),
  );
};
